export const SET_DATA = "SET_DATA";
export const SET_LANDLORD_ARRAY = "SET_LANDLORD_ARRAY"
export const SET_APARTMENT_ARRAY = 'SET_APARTMENT_ARRAY'
export const SET_RIDER_ARRAY = 'SET_RIDER_ARRAY'
export const CREAT_CLAIM = 'CREAT_CLAIM'
export const SET_CLAIMID = 'SET_CLAIMID'
export const SET_AGREEMENTID = 'SET_AGREEMENTID'
export const SET_LEDGERID = 'SET_LEDGERID'
export const SET_ERR = 'SET_ERR'
export const SET_POLICY_DUPLICATED = 'SET_POLICY_DUPLICATED'
export const SET_RESULT = 'SET_RESULT'
export const SET_INITIATE = 'SET_INITIATE'